import { render, staticRenderFns } from "./DTable.vue?vue&type=template&id=728b0744&scoped=true"
import script from "./DTable.vue?vue&type=script&lang=js"
export * from "./DTable.vue?vue&type=script&lang=js"
import style0 from "./DTable.vue?vue&type=style&index=0&id=728b0744&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b0744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728b0744')) {
      api.createRecord('728b0744', component.options)
    } else {
      api.reload('728b0744', component.options)
    }
    module.hot.accept("./DTable.vue?vue&type=template&id=728b0744&scoped=true", function () {
      api.rerender('728b0744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/DTable.vue"
export default component.exports